import { render, staticRenderFns } from "./select-api-type.vue?vue&type=template&id=9b8cf07c"
import script from "./select-api-type.vue?vue&type=script&lang=ts"
export * from "./select-api-type.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports